
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { CountdownController } from './CountdownController';

export const countdown = defineCommand(
    'countdown',
    'Countdown',
    cc => {
        cc.resolve(CountdownController).invoke();
    }
);

export const inGadgetCommands = () => inCommands(
    countdown
);
